import React, {
  useEffect,
} from 'react';

import {
  createPortal,
} from 'react-dom';

import {
  useAuth,
} from '../AuthContext';

import LoginSection
  from './LoginSection';

import './LoginModal.css';

export default function LoginModal({
  open,
  onClose,
}) {
  const {
    signIn,
  } = useAuth();

  useEffect(
    () => {
      if (
        !open
      ) {
        return undefined;
      }

      const previousOverflow =
        document.body.style.overflow;

      document.body.style.overflow =
        'hidden';

      const handleKeyDown = (
        event,
      ) => {
        if (
          event.key ===
          'Escape'
        ) {
          if (
            typeof onClose ===
            'function'
          ) {
            onClose();
          }
        }
      };

      document.addEventListener(
        'keydown',
        handleKeyDown,
      );

      return () => {
        document.body.style.overflow =
          previousOverflow;

        document.removeEventListener(
          'keydown',
          handleKeyDown,
        );
      };
    },
    [
      open,
      onClose,
    ],
  );

  if (
    !open
  ) {
    return null;
  }

  const handleLoginSuccess =
    () => {
      if (
        typeof onClose ===
        'function'
      ) {
        onClose();
      }
    };

    const handleBackdropMouseDown =
    (
      event,
    ) => {
      if (
        event.target !==
        event.currentTarget
      ) {
        return;
      }

      if (
        typeof onClose ===
        'function'
      ) {
        onClose();
      }
    };

  const modalContent = (
    <div
      className="login-modal-backdrop"
      onMouseDown={
        handleBackdropMouseDown
      }
    >
      <div
        className="login-modal"
        role="dialog"
        aria-modal="true"
        onMouseDown={(
          event,
        ) => {
          event.stopPropagation();
        }}
      >
        <button
          type="button"
          className="login-modal-close"
          onClick={
            onClose
          }
        >
          <span
            aria-hidden="true"
          >
            ×
          </span>
        </button>

        <LoginSection
          variant="modal"
          loginAction={
            signIn
          }
          onLoginSuccess={
            handleLoginSuccess
          }
        />
      </div>
    </div>
  );

  return createPortal(
    modalContent,
    document.body,
  );
}